<div class="container-fluid">
  <div class="row">

    @for(option of options; track $index) {

      <div class="col-12 mb-2">
        <div>
          <input 
            class="form-check-input me-2" 
            type="checkbox" 
            [name]="option.idPregunta" 
            [id]="option.idPregunta + '-' + option.idRespuesta"
            (change)="onSelect(option, $event)"
            aria-label="...">
            <label 
              class="form-check-label" 
              [for]="option.idPregunta + '-' + option.idRespuesta">
              {{ option.respuesta }}
            </label>
        </div>
        
      </div>

      @if(option.permiteTexto) {
        <div class="col-12 mb-3">
          <div>
            <input 
              type="text" 
              class="form-control" 
              placeholder="Especifique"
              [(ngModel)]="option.respuestaTexto"
              [disabled]="!selected.includes(option)"
              [maxlength]="answerMaxLength">
          </div>
        </div>
      }

    }

  </div>
</div>